import { Outlet } from '@tanstack/react-router'
import { RouterFocusManager } from '@/shared/components/RouterFocusManager'

/**
 * Root layout component — wraps all routes.
 * Mounts RouterFocusManager inside the Router context so it can subscribe to route events.
 */
export function RootLayout() {
  return (
    <>
      <RouterFocusManager />
      <Outlet />
    </>
  )
}
